import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
export const cameraFailedToReadBarcodeError = (error: unknown) => {
  reportMessageToSentry(
    "Camera: Barcode detection failed",
    { errorMessage: JSON.stringify(error) },
    "error"
  );
};
